import { useEffect } from 'react';
import { useEditorStore } from '~/shell/Store';
import { useSequenceStore } from '~/training/sequence/SequenceStore';
import { accordionLearnBlockerId } from './accordionBlockerIds';

export function AccordionLearnerBlocker({
  accordionId,
  expandAllItems
}: {
  accordionId: string;
  expandAllItems: boolean;
}) {
  const { editorMode } = useEditorStore();
  const { addBlocker, removeBlocker } = useSequenceStore();

  useEffect(() => {
    if (editorMode || expandAllItems) return;
    const key = accordionLearnBlockerId(accordionId);
    addBlocker(key);
    return () => removeBlocker(key);
  }, [accordionId, expandAllItems, editorMode, addBlocker, removeBlocker]);

  return null;
}
